import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import SectionTabs from '../../components/SectionTabs';

const tabs = [
  {to:'sueldos',label:'Sueldos'},
  {to:'categorias',label:'Categorías'},
  {to:'tarifas-operaciones',label:'Tarifas de Operaciones'},
];
export default function SalarialPage() {
  const {pathname}=useLocation();
  const current=tabs.find(t=>pathname.endsWith('/'+t.to));
  return <><h1 className="page-title">Salarial</h1><nav className="employee-breadcrumbs" aria-label="Navegación salarial"><Link to="/sueldos" state={{employeeSection:false}}>Personal</Link> → <Link to="/sueldos/salarial">Salarial</Link>{current&&<> → <span>{current.label}</span></>}</nav><SectionTabs tabs={tabs} actions={<div id="salary-year-navigation" style={{marginLeft:"auto",display:"flex",alignItems:"center"}}/>}/></>;
}
